var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigureGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.712 15.1853C15.0078 12.7633 12.2977 11.9844 9.31023 11.9844C6.32273 11.9844 3.68733 12.9126 2.90845 15.1853C3.61149 16.223 4.56959 17.0624 5.6907 17.623C6.81181 18.1835 8.05824 18.4464 9.31023 18.3862C10.5619 18.4443 11.8076 18.1806 12.9284 17.6202C14.0491 17.0598 15.0075 16.2215 15.712 15.1853Z",
    fill: "#279D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31027 5.25183C10.1592 5.25183 10.9734 5.58907 11.5736 6.18935C12.1739 6.78963 12.5112 7.60379 12.5112 8.45272C12.5112 9.30165 12.1739 10.1158 11.5736 10.7161C10.9734 11.3164 10.1592 11.6536 9.31027 11.6536C8.46134 11.6536 7.64718 11.3164 7.04689 10.7161C6.44661 10.1158 6.10938 9.30165 6.10938 8.45272C6.10938 7.60379 6.44661 6.78963 7.04689 6.18935C7.64718 5.58907 8.46134 5.25183 9.31027 5.25183Z",
    fill: "#279D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31013 18.3862C14.0243 18.3862 17.8458 14.5646 17.8458 9.85047C17.8458 5.13633 14.0243 1.31476 9.31013 1.31476C4.59598 1.31476 0.774414 5.13633 0.774414 9.85047C0.774414 14.5646 4.59598 18.3862 9.31013 18.3862Z",
    stroke: "#279D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1384,
    height: 18.1384,
    fill: "white",
    transform: "translate(0.240967 0.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureGreen);
export default __webpack_public_path__ + "static/media/figure_green.c1fade3a1ea4ad2a0f5ee8661573080b.svg";
export { ForwardRef as ReactComponent };